import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbRatingConfig } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { allCategory, CourseInfo } from 'src/app/model/course.model';
import { CourseService } from 'src/app/services/course.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ShareService } from 'src/app/services/share.service';

@Component({
  selector: 'app-learning-list',
  templateUrl: './learning-list.component.html',
  styleUrls: ['./learning-list.component.scss']
})
export class LearningListComponent implements OnInit {

  @Input() allCategory: allCategory[] = [];
  @Input() categoryVisDetails: CourseInfo[] = [];
  @Input() total_pages: number;
  @Input() current_page: number;
  @Input() number_of_page;
  @Output() send_index_number_subs = new EventEmitter();
  currentRate: number;
  role = '';
  loader = false;
  get permissions() {
    return JSON.parse(localStorage.getItem("permissions"));
  }

  constructor(
    private courseService: CourseService,
    private router: Router,
    private ns: NotificationService,
    rateConfig: NgbRatingConfig,
    private shareService: ShareService) {
    rateConfig.readonly = true;
    this.role = localStorage.getItem('role');
  }

  ngOnInit() {
    this.send_index_number_subs.emit('1+learner');
  }

  sendCourseDetails(id, course) {
    this.router.navigate(['/courses/single-course'], { queryParams: { course_id: id, course: course } });
  }

  redirect(link) {
    this.router.navigate([link]);
  }

  findIndexOf(slug, pmenusSlug) {
    let indexOfValue;
    indexOfValue = this.shareService.getIndexArr(slug, pmenusSlug)
    return indexOfValue;
  }

  Send_index(number) {
    this.send_index_number_subs.emit(number+'+learner');
  }

  check_previous(type) {
    if (type == 'Previous') {
      return this.current_page == this.number_of_page[0] ? true : false;
    }
  }

  check_next(type) {
    if (type == 'Next') {
      return this.current_page == this.total_pages ? false : true;
    }
  }

  get_number(number_of_page) {
    if(number_of_page != undefined) {
      return number_of_page
    } 
    return 1;
  }
}
